/*global swal*/

import './style.less';
import angular from 'angular';
import { skins } from '@prolaera/library';
import { merge } from 'lodash';

export default function($log, $transitions, $window, $stateParams, Swal, Upload, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.skins = skins;

  const { company_id } = ProfileClass.profileComplete.profile;

  $transitions.onExit({ exiting: 'app.admin.settings.company' }, () => {
    skins.forEach(({ value }) => angular.element('body').removeClass(value));
    const skin = vm.skin || 'skin-prolaera';
    angular.element('body').addClass(skin);
    return true;
  });

  vm.updateSkin = skin => {
    skins.forEach(({ value }) => angular.element('body').removeClass(value));
    angular.element('body').addClass(skin);
  };

  vm.removeLogo = size => delete vm.formData.logo[size];

  vm.uploadFile = (file, logo, btn, temp) => {
    if (!file) return;
    vm[btn] = true;

    ApiClass.companiesIdTypePut(
      { manage: true, id: ProfileClass.company_id, type: 'policies' },
      {
        policy: 'logo',
        file_type: file.type,
        file_name: file.name
      }
    )
      .then(({ data: { item: s3Policy } }) => uploadFile(file, btn, s3Policy))
      .then(link => {
        vm[btn] = false;
        if (vm.formData && !vm.formData.logo) vm.formData.logo = {};
        vm.formData.logo[logo] = link;
        vm.submit({ logo: vm.formData.logo }, false);
        delete vm[temp];
      })
      .catch(error => {
        vm[btn] = false;
        $log.error(error);
        throw error;
      });
  };

  vm.submit = (formData, reload = true) => {
    if (reload) vm.submitButton = true;
    ApiClass.companiesIdPatch({ manage: true, id: company_id }, formData)
      .then(() => {
        vm.submitButton = false;
        if (reload) $window.location.reload();
        Swal.toast('Updated!');
      })
      .catch(error => {
        vm.submitButton = false;
        $log.error(error);
        throw error;
      });
  };

  function uploadFile(file, btn, s3Policy) {
    return Upload.upload({
      url: s3Policy.filePolicy.action,
      data: s3Policy.filePolicy.fields,
      file: file,
      method: 'POST',
      skipAuthorization: true
    }).then(
      function() {
        return s3Policy.link;
      },
      function(resp) {
        vm[btn] = false;
        $log.error('Error status: ' + resp.status);
        throw new Error(`PDF UPLOADING ERROR ${$stateParams.id}`);
      },
      function(evt) {
        const pdfStaus = parseInt((100.0 * evt.loaded) / evt.total);
        vm.pdfProgress = `${pdfStaus}%`;
      }
    );
  }

  function cleanCompany(company) {
    const preferences = company.preferences || {};
    const template = {
      certificates: { adminOnly: false, applyApprovedOnly: false, requireDocumentUpload: false },
      certifications: { adminOnly: false },
      email: false,
      licenses: { adminOnly: false }
    };

    company.preferences = merge(template, preferences);

    return company;
  }

  function activate() {
    $log.debug('Company Controller Activated');
    vm.formData = {};

    ApiClass.companiesIdGet({ manage: true, id: company_id })
      .then(({ data: { company } }) => {
        company = cleanCompany(company);

        vm.skin = angular.copy(company.skin);
        vm.formData = company;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/company/index.js